import { useContext } from "react"
import MoveRegulationsLawActsContext from "../context/MoveRegulationsLawActsContext"

const useMoveRegulationsLawActs = () => {
    return useContext(MoveRegulationsLawActsContext);
}

export default useMoveRegulationsLawActs